"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDeliveryTip = void 0;

var _tslib = require("tslib");

var _reactQuery = require("react-query");

var _api = require("../api");

var _types = require("../types");

var useDeliveryTip = function useDeliveryTip() {
  return (0, _reactQuery.useMutation)(function (req) {
    return (0, _api.fetchGetCartTotalPrices)((0, _tslib.__assign)((0, _tslib.__assign)({}, req), {
      action: _types.DeliveryActions.Tip
    }));
  });
};

exports.useDeliveryTip = useDeliveryTip;